import { useTranslation } from 'react-i18next'

import './ListObjectCell.scss'
import { Icon } from '@/Atomic/Atoms/Icon'
import { CellRendererParams } from '@/Components/EntityTable/types'
import { DataClassName } from '@/Data/const'

export const ListObjectCell = ({ dataItem }: CellRendererParams) => {
  const { t } = useTranslation()
  const entityType = dataItem.get('entityType')

  if (!entityType) {
    return <span className="list-object-cell">-</span>
  }

  const isCompanyList = entityType === DataClassName.COMPANY
  const label = isCompanyList
    ? t('pages.companies.title')
    : t('components.contact.title')

  return (
    <span className="list-object-cell">
      <Icon icon={isCompanyList ? 'building' : 'user-multiple'} size="sm" />
      <span className="list-object-cell__label">{label}</span>
    </span>
  )
}
